import { keyframes } from '@emotion/core';

export const fadeInKeyframes = keyframes({
  '0%': {
    opacity: 0,
  },
  '100%': {
    opacity: 1,
  },
});

export const fadeInAndUpKeyframes = keyframes({
  '0%': {
    opacity: 0,
    transform: ['translateY(15px)'],
  },
  '100%': {
    opacity: 1,
    transform: ['translateY(0px)'],
  },
});
